import React from "react";

export const indexContext = React.createContext(0);